import React from 'react';
import { Box, Typography, Divider } from '@material-ui/core';
import { useStyles } from './styles.esm.js';
import { Skeleton } from '@material-ui/lab';

const SkeletonComponent = ({ title, description }) => {
  const { descriptionContent, skeletonContent } = useStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { my: 1 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, title), /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(Box, { className: descriptionContent }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, description)), /* @__PURE__ */ React.createElement(Skeleton, { className: skeletonContent, animation: "wave" }));
};

export { SkeletonComponent };
//# sourceMappingURL=skeletonComponent.esm.js.map
